import { render, staticRenderFns } from "./DictPositionVariantsListPage.vue?vue&type=template&id=87e5322e&"
import script from "./DictPositionVariantsListPage.vue?vue&type=script&lang=ts&"
export * from "./DictPositionVariantsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports